// extracted by mini-css-extract-plugin
export default {"layout":"Root_layout__8vD3n"};